/* RECKLESS — Venta mayorista: armador de pedido.
   Los precios salen del DOM (data-list / data-web, en centavos) que pinta Liquid.
   La regla de precio vive en unitPrice(): descuento sobre lista y tope para
   polerones. La ganancia mostrada es lista − precio mayorista. */
(function () {
  'use strict';

  var CAT = { lentes: 'Lentes de sol', beanies: 'Beanies', snapbacks: 'Snapbacks', polerones: 'Polerones' };

  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    if (!root || root.dataset.rkmInit === '1') return;
    root.dataset.rkmInit = '1';

    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-rkm-cfg') || '{}'); } catch (e) { cfg = {}; }
    cfg.t1a = +cfg.t1a || 300000; cfg.t1p = +cfg.t1p || 40;
    cfg.t2a = +cfg.t2a || 600000; cfg.t2p = +cfg.t2p || 50;
    cfg.ra = +cfg.ra || cfg.t1a;
    cfg.capPol = +cfg.capPol || 40;

    var lines = [].slice.call(root.querySelectorAll('[data-rkm-line]'));
    var cards = [].slice.call(root.querySelectorAll('[data-rkm-card]'));
    var tabs = [].slice.call(root.querySelectorAll('[data-rkm-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-rkm-panel]'));
    var sum = root.querySelector('[data-rkm-summary]');
    var body = root.querySelector('[data-rkm-body]');
    var submit = root.querySelector('[data-rkm-submit]');
    var form = root.querySelector('form#rkm-form');
    var errBox = root.querySelector('[data-rkm-errors]');
    var wa = root.querySelector('[data-rkm-wa]');
    var bar = root.querySelector('[data-rkm-bar]');
    var pad = root.querySelector('[data-rkm-pad]');
    var barUnits = root.querySelector('[data-rkm-bar-units]');
    var barTotal = root.querySelector('[data-rkm-bar-total]');
    var exampleCells = [].slice.call(root.querySelectorAll('[data-rkm-ex]'));
    var exampleGains = [].slice.call(root.querySelectorAll('[data-rkm-ex-gain]'));
    var kinds = [].slice.call(root.querySelectorAll('[data-rkm-kind]'));
    function isReorder() { return kinds.length ? kinds.some(function (k) { return k.checked && k.dataset.rkmKind === 'reorder'; }) : !!cfg.reorder; }
    function minAmount() { return isReorder() ? cfg.ra : cfg.t1a; }
    var reorderOnly = [].slice.call(root.querySelectorAll('[data-rkm-reorder-only]'));
    function syncReorderFields() {
      var on = isReorder();
      reorderOnly.forEach(function (box) {
        box.hidden = !on;
        [].slice.call(box.querySelectorAll('input')).forEach(function (i) { i.required = on; if (!on) i.value = ''; });
      });
    }
    kinds.forEach(function (k) { k.addEventListener('change', function () { syncReorderFields(); render(); }); });
    syncReorderFields();

    /* ---------- ver más ---------- */
    [].slice.call(root.querySelectorAll('[data-rkm-more]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-rkm-panel]');
        [].slice.call(panel.querySelectorAll('[data-rkm-extra]')).forEach(function (c) { c.hidden = false; });
        btn.hidden = true;
      });
    });

    /* ---------- pestañas ---------- */
    function showTab(key) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.rkmTab === key)); });
      panels.forEach(function (p) { p.hidden = p.dataset.rkmPanel !== key; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.dataset.rkmTab); }); });
    if (tabs.length) showTab(tabs[0].dataset.rkmTab);

    /* ---------- precio unitario ---------- */
    function totalAt(items, pct) {
      var m = 0;
      items.forEach(function (it) { m += unitPrice(it.list, it.cat, pct) * it.q; });
      return m;
    }
    /* tramo 2 cuando el total, ya con el % del tramo 2, llega a t2a */
    function pctFor(items) { return totalAt(items, cfg.t2p) >= cfg.t2a ? cfg.t2p : cfg.t1p; }
    function pctForCat(pct, cat) { return cat === 'polerones' ? Math.min(pct, cfg.capPol) : pct; }
    function unitPrice(list, cat, pct) {
      return Math.round(list * (1 - pctForCat(pct, cat) / 100));
    }

    /* ---------- lectura del estado ---------- */
    function read() {
      var perCat = {}, total = 0, items = [];
      lines.forEach(function (ln) {
        var input = ln.querySelector('input');
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        if (q === 0 && input.value !== '' && input.value !== '0') input.value = 0;
        var cat = ln.dataset.cat;
        perCat[cat] = (perCat[cat] || 0) + q;
        total += q;
        if (q > 0) items.push({ cat: cat, q: q, title: ln.dataset.title, vtitle: ln.dataset.vtitle || '', list: +ln.dataset.list / 100 });
      });
      var pct = pctFor(items);
      var money = 0, listTotal = 0;
      items.forEach(function (it) { it.unit = unitPrice(it.list, it.cat, pct); it.sub = it.unit * it.q; money += it.sub; listTotal += it.list * it.q; });
      /* cuánto falta, en plata a precio mayorista, para el mínimo y para el tramo 2 */
      var minA = minAmount();
      var toMin = Math.max(0, minA - money);
      var toT2 = pct === cfg.t2p ? 0 : Math.max(0, cfg.t2a - totalAt(items, cfg.t2p));
      var valid = items.length > 0 && money >= minA;
      return { perCat: perCat, total: total, pct: pct, items: items, money: money, listTotal: listTotal, gain: listTotal - money, minA: minA, reorder: isReorder(), toMin: toMin, toT2: toT2, valid: valid };
    }

    /* ---------- render ---------- */
    function tierLabel(pct, s) {
      if (!s.valid && s.pct !== cfg.t2p) return 'a ' + cfg.t1p + ' % desde ' + fmt(cfg.t1a);
      return pct === cfg.t2p ? pct + ' % · pedidos desde ' + fmt(cfg.t2a) : pct + ' % · pedidos desde ' + fmt(cfg.t1a);
    }

    function render() {
      var s = read();

      /* tarjetas: precio unitario del tramo vigente */
      cards.forEach(function (card) {
        var cat = card.dataset.cat;
        var list = +card.dataset.list / 100;
        var unit = unitPrice(list, cat, s.pct);
        var u = card.querySelector('[data-rkm-unit]');
        var l = card.querySelector('[data-rkm-unit-lbl]');
        var g = card.querySelector('[data-rkm-gain]');
        if (u) u.textContent = fmt(unit);
        if (l) l.textContent = tierLabel(pctForCat(s.pct, cat), s);
        if (g) g.textContent = fmt(list - unit);
        var on = [].slice.call(card.querySelectorAll('[data-rkm-line] input')).some(function (i) { return (parseInt(i.value, 10) || 0) > 0; });
        card.classList.toggle('is-on', on);
      });

      /* contadores en las pestañas */
      tabs.forEach(function (t) {
        var n = t.querySelector('[data-rkm-tab-n]');
        if (n) n.textContent = s.perCat[t.dataset.rkmTab] ? s.perCat[t.dataset.rkmTab] : '';
      });

      /* tabla de ejemplo por categoría (desde precio de lista de referencia) */
      exampleCells.forEach(function (td) {
        var list = +td.dataset.list / 100;
        td.innerHTML = '<b>' + fmt(unitPrice(list, td.dataset.cat, +td.dataset.pct)) + '</b>';
      });
      exampleGains.forEach(function (el) {
        var list = +el.dataset.list / 100;
        el.innerHTML = 'Ganas <b>' + fmt(list - unitPrice(list, el.dataset.cat, +el.dataset.pct)) + '</b>';
      });

      /* resumen */
      if (sum) {
        if (!s.items.length) {
          sum.innerHTML = '<div class="rkm-sum__empty">Aún no agregas productos. Elige modelos y cantidades en el catálogo de arriba.</div>';
        } else {
          var html = '';
          Object.keys(CAT).forEach(function (c) {
            var its = s.items.filter(function (i) { return i.cat === c; });
            if (!its.length) return;
            html += '<div class="rkm-sum__cat"><header>' + CAT[c] + '<span>' + s.perCat[c] + ' u</span></header><ul>';
            its.forEach(function (i) {
              html += '<li><span><b>' + esc(i.title) + (i.vtitle ? ' · ' + esc(i.vtitle) : '') + '</b> × ' + i.q + ' · ' + fmt(i.unit) + '/u</span><span>' + fmt(i.sub) + '</span></li>';
            });
            html += '</ul></div>';
          });
          var tramo = '<em>' + s.pct + ' %</em> sobre lista' + (s.perCat.polerones ? ' (polerones ' + pctForCat(s.pct, 'polerones') + ' %)' : '');
          html += '<div class="rkm-sum__tot"><div><span>Unidades</span><b>' + s.total + '</b></div><div><span>Descuento</span><span>' + tramo + '</span></div><div><span>Total estimado, IVA incluido</span><b>' + fmt(s.money) + '</b></div>' +
            '<div class="rkm-sum__gain"><span>Valor a precio de lista</span><span>' + fmt(s.listTotal) + '</span></div>' +
            '<div class="rkm-sum__gain"><span>Ganas vendiendo a precio de lista</span><em>' + fmt(s.gain) + '</em></div></div>';
          var msg = '';
          if (!s.valid) msg = '<div class="rkm-sum__msg">Te faltan ' + fmt(s.toMin) + ' para el mínimo de ' + fmt(s.minA) + (s.reorder ? ' de una recompra' : ' de un primer pedido') + '.</div>';
          else if (s.pct < cfg.t2p) msg = '<div class="rkm-sum__msg is-ok">Pedido válido. Suma ' + fmt(s.toT2) + ' más y todo el pedido pasa al ' + cfg.t2p + ' % con envío incluido.</div>';
          else msg = '<div class="rkm-sum__msg is-ok">Pedido válido con el descuento máximo y envío incluido.</div>';
          html += msg;
          sum.innerHTML = html;
        }
      }

      /* texto que viaja en el correo */
      if (body) {
        var t = 'PEDIDO MAYORISTA — recklesschile.com/pages/mayorista\n';
        t += (s.reorder ? 'RECOMPRA' : 'PRIMER PEDIDO') + ' · Unidades: ' + s.total + ' · Tramo: ' + s.pct + ' % sobre precio de lista' + (s.pct === cfg.t2p ? ' · envío incluido' : '') + (s.valid ? '' : ' (bajo el mínimo)') + '\n\n';
        Object.keys(CAT).forEach(function (c) {
          var its = s.items.filter(function (i) { return i.cat === c; });
          if (!its.length) return;
          t += CAT[c] + ' (' + s.perCat[c] + ' u):\n';
          its.forEach(function (i) { t += ' - ' + i.title + (i.vtitle ? ' · ' + i.vtitle : '') + ' × ' + i.q + ' · ' + fmt(i.unit) + '/u = ' + fmt(i.sub) + '\n'; });
          t += '\n';
        });
        t += 'TOTAL ESTIMADO (IVA incluido): ' + fmt(s.money) + '\n';
        t += 'Valor a precio de lista: ' + fmt(s.listTotal) + ' · Ganancia potencial del cliente: ' + fmt(s.gain) + '\n';
        t += 'Precios referenciales según lista vigente.' + (s.pct === cfg.t2p ? ' Envío incluido.' : ' Envío por cotizar.') + '\n';
        body.value = t;
      }

      /* botón, WhatsApp, barra */
      if (submit) submit.disabled = !s.valid;
      if (wa) {
        var num = (wa.dataset.num || '').replace(/\D/g, '');
        if (num && body) wa.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent('Hola, quiero hacer un pedido mayorista:\n\n' + body.value);
      }
      if (bar) {
        var on = s.total > 0;
        bar.classList.toggle('is-on', on);
        if (pad) pad.classList.toggle('is-on', on);
        if (barUnits) barUnits.textContent = s.total + ' u · ' + (s.valid ? s.pct + ' %' : 'mín. ' + fmt(s.minA));
        if (barTotal) barTotal.textContent = fmt(s.money);
      }
      if (errBox && s.valid) errBox.hidden = true;
    }

    /* ---------- steppers ---------- */
    lines.forEach(function (ln) {
      var input = ln.querySelector('input');
      ln.querySelector('[data-dec]').addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); render(); });
      ln.querySelector('[data-inc]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; render(); });
      input.addEventListener('input', render);
      input.addEventListener('change', render);
      input.addEventListener('focus', function () { input.select(); });
    });

    /* ---------- envío ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        var s = read();
        var errs = [];
        if (!s.valid) errs.push('El pedido mínimo es ' + fmt(s.minA) + ' a precio mayorista (llevas ' + fmt(s.money) + ').');
        [].slice.call(form.querySelectorAll('[required]')).forEach(function (f) {
          if (!String(f.value || '').trim()) errs.push('Falta completar: ' + (f.dataset.label || f.name) + '.');
        });
        if (errs.length) {
          e.preventDefault();
          if (errBox) {
            errBox.innerHTML = '<b>Revisa esto antes de enviar:</b><ul>' + errs.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
            errBox.hidden = false;
            errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          render();
          if (submit) { submit.disabled = true; submit.querySelector('span') && (submit.querySelector('span').textContent = 'Enviando…'); }
        }
      });
    }

    render();
  }

  function initFaq(root) {
    if (!root || root.dataset.rkmFaqInit === '1') return;
    root.dataset.rkmFaqInit = '1';
    var items = [].slice.call(root.querySelectorAll('.rk2-faq'));
    function open(item, on) {
      var panel = item.querySelector('.rk2-faq__panel');
      item.setAttribute('aria-expanded', String(on));
      if (!panel) return;
      panel.style.maxHeight = on ? (panel.scrollHeight + 20) + 'px' : '0px';
      panel.style.opacity = on ? '1' : '0';
    }
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var was = item.getAttribute('aria-expanded') === 'true';
        items.forEach(function (o) { open(o, false); });
        if (!was) open(item, true);
      });
      if (item.getAttribute('aria-expanded') === 'true') open(item, true);
    });
  }

  function boot(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-rkm]')).forEach(init);
    [].slice.call((scope || document).querySelectorAll('[data-rkm-faq]')).forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
